var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-icon',{staticClass:"mail",attrs:{"large":"","color":"primary"}}),_c('div',{staticClass:"container__message"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }